import styled from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const UpdatesAlertWrapper = styled.div`
    background-color: ${colors.BLACK};
`;

export const UpdatesAlertContainer = styled.div`
    padding: 0 20px;
    
    ${MediaQuery.xLarge`
    padding: 0 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    
    >div, >main {
        max-width: 1320px;
        width: 100%;
    }
    `};
`;

export const AlertContent = styled.div`
    width: 100%;
    padding: 16px 0;
    display: flex;
    color: ${colors.WHITE};
    font-size: 1.4rem;
    font-weight: 500;
`;

export const AlertCounter = styled.div`
        display: flex;
        margin-right: 24px;

       span {
           margin: 0 8px;
       }

       .rotated {
           transform: rotate(180deg);
       }
`;

export const AlertText = styled.div`
    flex-grow: 1;
    
    a,
    a:hover,
    a:visited,
    a:active {
        color: ${colors.WHITE};
        text-decoration: underline;
        margin-left: 8px;
    }
`;

export const AlertClose = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
`;
